import { useWatch } from 'react-hook-form';
import { dvtSearchColumns, QUERY_KEYS, vatTuSearchColumns } from '@/constants';
import { SearchField, FormField } from '@/components/custom/erp';
import { DonViTinh, VatTu } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

function BasicInfo({
  mode,
  donViTinh,
  setDonViTinh,
  vatTu,
  setVatTu
}: {
  mode: FormMode;
  donViTinh: DonViTinh | null;
  setDonViTinh: (donViTinh: DonViTinh) => void;
  vatTu: VatTu | null;
  setVatTu: (vatTu: VatTu) => void;
}) {
  const heSo = useWatch({ name: 'he_so' });

  return (
    <div className='space-y-3 p-6'>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-32 sm:min-w-32'>Mã vật tư</Label>
        <SearchField<VatTu>
          type='text'
          disabled={mode === 'view'}
          dialogTitle='Danh mục vật tư'
          value={vatTu?.ma_vt || ''}
          relatedFieldValue={vatTu?.ten_vt || ''}
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          onRowSelection={setVatTu}
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}`}
          searchColumns={vatTuSearchColumns}
          className='w-100'
        />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-32 sm:min-w-32'>Đvt</Label>
        <SearchField<DonViTinh>
          type='text'
          disabled={mode === 'view'}
          value={donViTinh?.dvt || ''}
          relatedFieldValue={donViTinh?.ten_dvt || ''}
          columnDisplay='dvt'
          displayRelatedField='ten_dvt'
          onRowSelection={setDonViTinh}
          dialogTitle='Đơn vị tính'
          searchEndpoint={`/${QUERY_KEYS.DON_VI_TINH}`}
          searchColumns={dvtSearchColumns}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-32 sm:min-w-32'>Hệ số</Label>
        <FormField type='number' name='he_so' className='w-32' disabled={mode === 'view'} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label htmlFor='trang_thai' className='mb-2 sm:mb-0 sm:w-32 sm:min-w-32'>
          Trạng thái
        </Label>
        <FormField
          id='trang_thai'
          type='select'
          name='trang_thai'
          className='w-44'
          options={[
            { label: '1. Còn sử dụng', value: '1' },
            { label: '0. Không sử dụng', value: '0' }
          ]}
          disabled={mode === 'view'}
        />
      </div>
    </div>
  );
}

export default BasicInfo;
